import { render } from "./RenderClientChart.vue?vue&type=template&id=70be3fb4"
import script from "./RenderClientChart.vue?vue&type=script&lang=js"
export * from "./RenderClientChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__